import { class_type } from "./fable_modules/fable-library-js.4.18.0/Reflection.js";
import { ofArray, choose, toArray, collect } from "./fable_modules/fable-library-js.4.18.0/List.js";
import { MenuProps, Menu, MenuItem, MenuItemProps } from "./Interop/Antd/Menu.fs.js";
import * as react from "react";
import Navigation from "../src/Navigation.css";

export class Page {
    constructor(route, navComponent) {
        this.route = route;
        this.navComponent = navComponent;
    }
    get Routes() {
        const this$ = this;
        return this$.route;
    }
    get NavComponent() {
        const this$ = this;
        return this$.navComponent;
    }
}

export function Page_$reflection() {
    return class_type("Loop54.Portal.WebUI.Navigation.Page", undefined, Page);
}

export function Page_$ctor_Z7AC995BC(route, navComponent) {
    return new Page(route, navComponent);
}

export class PageWithoutNavComponent {
    constructor(route) {
        this.route = route;
    }
    get Routes() {
        const this$ = this;
        return this$.route;
    }
    get NavComponent() {
        return undefined;
    }
}

export function PageWithoutNavComponent_$reflection() {
    return class_type("Loop54.Portal.WebUI.Navigation.PageWithoutNavComponent", undefined, PageWithoutNavComponent);
}

export function PageWithoutNavComponent_$ctor_1FEFDAB5(route) {
    return new PageWithoutNavComponent(route);
}

export class PageGroup {
    constructor(key, name, icon, pages) {
        this.key = key;
        this.name = name;
        this.icon = icon;
        this.pages = pages;
    }
    get Routes() {
        const this$ = this;
        return collect((p) => p.Routes, this$.pages);
    }
    get NavComponent() {
        const this$ = this;
        return new MenuItem(ofArray([new MenuItemProps(0, [this$.key]), new MenuItemProps(1, [react.createElement("span", {}, this$.name)]), new MenuItemProps(2, [this$.icon]), new MenuItemProps(3, [toArray(choose((p) => p.NavComponent, this$.pages))])]));
    }
}

export function PageGroup_$reflection() {
    return class_type("Loop54.Portal.WebUI.Navigation.PageGroup", undefined, PageGroup);
}

export function PageGroup_$ctor_Z104CF0BE(key, name, icon, pages) {
    return new PageGroup(key, name, icon, pages);
}

export function createRootNavComponent(pages, defaultOpenKeys, defaultSelectedKeys) {
    const pagesWitNavComponents = toArray(choose((p) => p.NavComponent, pages));
    return Menu(ofArray([new MenuProps(0, ["inline"]), new MenuProps(3, [Navigation.menu]), new MenuProps(1, [defaultOpenKeys]), new MenuProps(2, [defaultSelectedKeys]), new MenuProps(4, [pagesWitNavComponents])]));
}

